export type PromptItem = {
  title: string;
  desc: string;
};

export type PredefinedPromptMap = {
  [key: string]: PromptItem[];
};

export const predefinedPrompt: PredefinedPromptMap = {
  "Cumulative people count": [
    {
      title: "Visitor trend analysis",
      desc: "Is there a consistent increase or decrease in the number of visitors during a specific period?"
    },
    {
      title: "Peak traffic analysis",
      desc: "What are the busiest times and days for each location?"
    },
    {
      title: "Trend prediction",
      desc: "Can you predict the number of visitors for the next few weeks?"
    }
  ],
  // 다른 타입들도 여기에 추가 가능
  "People occupancy": [
    {
      title: "Visitor trend analysis",
      desc: "Is there a consistent trend of increase or decrease in occupancy during a specific period?"
    },
    {
      title: "Peak traffic analysis",
      desc: "What are the busiest times and days for each location?"
    },
    {
      title: "Trend prediction ",
      desc: "Can you predict the number of visitors for the next few weeks?"
    }
  ],
  "People queues": [
    {
      title: "People queues trend analysis",
      desc: "Are there any locations where the number of waiting customers and wait times suddenly increased? When did this surge happen?"
    },
    {
      title: "Peak traffic analysis",
      desc: "Which specific day and time frame sees the most customers waiting in line at each store?"
    },
    {
      title: "Trend prediction",
      desc: "Can you predict the number of people in queues over the next few weeks based on historical data?"
    }
  ],
  "Visitor area traffic": [
    {
      title: "Visitor area traffic trend analysis",
      desc: "Are there any locations where the number of staying customers and their staying times suddenly increased? When did this surge occur?"
    },
    {
      title: "Peak traffic analysis",
      desc: "Which specific day and time period had the highest number of customers staying in the area at each location?"
    },
    {
      title: "Trend prediction",
      desc: "Can you predict the number of people in the area over the next few weeks based on historical visitor traffic data?"
    }
  ],
  "Crowd counting": [
    {
      title: "Crowd trend analysis",
      desc: "Is there a consistent increase or decrease in crowd size during a specific time period?"
    },
    {
      title: "Peak traffic analysis",
      desc: "What are the busiest times and days for each location?"
    },
    {
      title: "Trend prediction",
      desc: "Can you predict the crowd size for the next few weeks?"
    }
  ],
  "Slip & fall": [
    {
      title: "Incident patterns analysis",
      desc: "Can you analyze the incident occurrence status by location?"
    },
    {
      title: "Critical location identification",
      desc: "Which locations have the highest incident occurrence rates?"
    },
    {
      title: "Incident prediction",
      desc: "Can you forecast potential incident locations and timing for next few weeks?"
    }
  ],
  "Cumulative shopping cart count": [
    {
      title: "Trend analysis",
      desc: "Is there a consistent increase or decrease in the number of shopping carts during a specific time period?"
    },
    {
      title: "Peak traffic analysis",
      desc: "What are the busiest times and days at each location?"
    },
    {
      title: "Trend prediction",
      desc: "Can you predict the number of shopping carts for the next few weeks?"
    }
  ],
  "Shopping carts in use": [
    {
      title: "Trend analysis",
      desc: "Is there a consistent increase or decrease in the number of shopping carts in use during a specific time period?"
    },
    {
      title: "Peak traffic analysis",
      desc: "What are the busiest times and days for each location?"
    },
    {
      title: "Trend prediction",
      desc: "Can you predict the number of shopping carts for the next few weeks?"
    }
  ],
  "Shopping cart queues": [
    {
      title: "Peak traffic analysis",
      desc: "Which specific day and time frame sees the most shopping carts in line at each store?"
    },
    {
      title: "Shopping cart queues trend analysis",
      desc: "Are there any locations where the number of shopping carts and wait times suddenly increased? When did this surge occur?"
    },
    {
      title: "Trend prediction",
      desc: "Can you predict the number of shopping carts in queues over the next few weeks based on historical queue data?"
    }
  ],
  "Cumulative vehicle count": [
    {
      title: "Trend analysis",
      desc: "Is there a consistent increase or decrease in the number of vehicles during a specific time period?"
    },
    {
      title: "Peak traffic analysis",
      desc: "What are the busiest times and days at each location?"
    },
    {
      title: "Trend prediction",
      desc: "Can you predict the number of vehicles for the next few weeks?"
    }
  ],
  "Vehicle occupancy": [
    {
      title: "Trend analysis",
      desc: "Is there a consistent increase or decrease in the number of vehicles in use during a specific time period?"
    },
    {
      title: "Peak traffic analysis",
      desc: "What are the busiest times and days at each location?"
    },
    {
      title: "Trend prediction",
      desc: "Can you predict the number of vehicles for the next few weeks?"
    }
  ],
  "Vehicle queues": [
    {
      title: "Vehicle queues trend analysis",
      desc: "Are there any locations where the number of vehicles and wait times suddenly increased? When did this surge occur?"
    },
    {
      title: "Peak traffic analysis",
      desc: "Which specific day and time frame sees the most vehicles in line at each store?"
    },
    {
      title: "Trend prediction",
      desc: "Can you predict the number of vehicles in queues over the next few weeks based on historical queue data?"
    }
  ]
};
